export const FormDetalheDaObrigacao = {
  dataCancelamento: '',
  dataInclusao: '',
  dataPublicacaoAto: '',
  dataQuitacao: '',
  dataSituacao: '',
  descAmparoLegal: '',
  descComplemento: '',
  orgao: null,
  descTipoAto: '',
  flagSituacao: '',
  idenAmparoLegal: null,
  idenObrigacao: null,
  idenOrgao: null,
  idenPessoa: null,
  idenTipoAto: null,
  idenTipoCertidao: null,
  listaAmparoLegalObrigacao: [],
  nomePessoa: '',
  nomeTipoCertidao: '',
  numrAto: '',
  numrCpf: '',
  statObrigacao: '',
  valrBruto: null,
  valrEmolumento: null,
  valrHonorario: null,
  valrIr: null,
  valrOutro: null,
}

export const consultaManterObrigacao = {
  flagQuitadaFolha: false,
  flagQuitada: false,
  flagCompensada: false,
  flagAutenticacao: false,
  flagEmitida: false,
  checkCertidoesNaoEmitidas: false,
  numrCertidao: null,
  pessoa: '',
  numrCpf: "",
  numrMatricula: "",
  numrCertidao: ""

}


const url = "/obrigacoes";
const id = "id";

export function pesquisaAll(paginacao) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/ativos/paginado?${paginacao}`).then((res) => {
      resolve(res.data);
    })
  })
}

export function buscarPeloCodigo(codigo) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${codigo}`).then((res) => {
      resolve(res.data);
    })
  })
}

export function buscaGenerica(parm, paginacao) {

  return new Promise((resolve, reject) => {
    window.$http.post(`${url}/buscagenerica?${paginacao}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    })
  })
}

export function pesquisar(filtro) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}?${filtro}`).then((res) => {
      resolve(res.data);
    });
  })
}

export function pesquisarAll() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}`).then((res) => {
      resolve(res.data);
    })
  })
}

export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[id] && parm[id] != 0) {
      await atualizar(parm).then((res) => {
        resolve({ ...res, type: "UPD" });
      });
    } else {
      await criar(parm).then((res) => {
        resolve({ ...res, type: "INS" });
      })
    }
  })
}

export function remover(data) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${data}`).then((res) => {
      resolve();
    })
  })
}

export function atualizar(iden, parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/${iden}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    })
  })
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    })
  })
}

export function relatorioObrigacao(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`/relatorios/gerarrelcreditosalarial`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    })
  })
}
